export default (props, vars) => () => {
  const token = vars?.['defaultUseParams1']?.['token'];
  window.context
    ? (window.context.auth = { token })
    : (window.context = { auth: { token } });
  vars?.['usestateisauthtokenset']?.['setState'](true);
};
